import { IonDate } from '../components/IonDate';

const CheckNotNull = Symbol('CheckNotNull');

class MembershipRegistration {
    public membership_registrationID: string = '';
    public initiatorID: string = '';
    public paymentID: string = '';
    public datetime_created: Date = new Date();

    constructor(
        membership_registrationID: string,
        initiatorID: string,
        paymentID: string,
        datetime_created: string
    ) {
        this.membership_registrationID = this[CheckNotNull](membership_registrationID) ? membership_registrationID : '';
        this.initiatorID = this[CheckNotNull](initiatorID) ? initiatorID : '';
        this.paymentID = this[CheckNotNull](paymentID) ? paymentID : '';
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : new Date();
    }

    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    }
}
export default MembershipRegistration;